export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_09.0067ab56.png";